import { render, staticRenderFns } from "./AgreeToTermsPopup.vue?vue&type=template&id=16d62682&scoped=true&"
import script from "./AgreeToTermsPopup.vue?vue&type=script&lang=js&"
export * from "./AgreeToTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./AgreeToTermsPopup.vue?vue&type=style&index=0&id=16d62682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d62682",
  null
  
)

export default component.exports